// tslint:disable
// this is an auto generated file. This will be overwritten

export const syncPrivateWebSettings = `query SyncPrivateWebSettings(
  $filter: ModelPrivateWebSettingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPrivateWebSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      accept_email
      owner
      _version
      _deleted
      _lastChangedAt
    }
    nextToken
    startedAt
  }
}
`;
export const getPrivateWebSetting = `query GetPrivateWebSetting($id: ID!) {
  getPrivateWebSetting(id: $id) {
    id
    accept_email
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const listPrivateWebSettings = `query ListPrivateWebSettings(
  $filter: ModelPrivateWebSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrivateWebSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      accept_email
      owner
      _version
      _deleted
      _lastChangedAt
    }
    nextToken
    startedAt
  }
}
`;
export const syncPrivateEnquetes = `query SyncPrivateEnquetes(
  $filter: ModelPrivateEnqueteFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPrivateEnquetes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      enquete1
      owner
      _version
      _deleted
      _lastChangedAt
    }
    nextToken
    startedAt
  }
}
`;
export const getPrivateEnquete = `query GetPrivateEnquete($id: ID!) {
  getPrivateEnquete(id: $id) {
    id
    enquete1
    owner
    _version
    _deleted
    _lastChangedAt
  }
}
`;
export const listPrivateEnquetes = `query ListPrivateEnquetes(
  $filter: ModelPrivateEnqueteFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrivateEnquetes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      enquete1
      owner
      _version
      _deleted
      _lastChangedAt
    }
    nextToken
    startedAt
  }
}
`;
